import React, { Component } from "react";

import Video from "../../Components/Video";

class MayuII extends Component {
  render() {
    return (
      <div className="mayu-ii">
        <Video video={"https://www.youtube.com/embed/V7XYp6qNCHg"} />
      </div>
    );
  }
}

export default MayuII;
